import React from 'react';
import { Move } from 'lucide-react';

interface EmptyStateProps {
  isEditing: boolean;
  onAddComponent?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ isEditing, onAddComponent }) => {
  return (
    <div className="text-center py-16">
      <div className="text-gray-400 mb-4">
        <Move size={48} className="mx-auto" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">No components yet</h3>
      <p className="text-gray-600 mb-6">Start building your page by adding components</p>
      {isEditing && (
        <button onClick={onAddComponent} className="btn-primary">
          Add Your First Component
        </button>
      )}
    </div>
  );
};
